<template>
  <div class="mainContainer">
    <div class="filterContainer">
      <el-form :inline="true" :model="filterParam">
<!--        <el-form-item label="年份" prop="year">-->
<!--          <el-date-picker-->
<!--              style="width: 100px"-->
<!--              v-model="filterParam.year"-->
<!--              type="year"-->
<!--              placeholder="选择年">-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
        <el-form-item label="地区" prop="countyname">
          <el-select
              style="width: 120px"
              v-model="filterParam.countyname"
              placeholder="请选择地区"
              filterable
              clearable
              @change="initCheckStudentList()"
          >
            <el-option
                v-for="cgn in countynameList"
                :key="cgn"
                :label="cgn"
                :value="cgn">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学校" prop="schoolName">
          <el-select
              style="width: 120px"
              v-model="filterParam.schoolName"
              placeholder="请选择学校"
              filterable
              clearable
              @change="changeSchool()"
          >
            <el-option
                v-for="cgn in schoolNameList"
                :key="cgn"
                :label="cgn"
                :value="cgn">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="年级" prop="gradeName">
          <el-select
              style="width: 120px"
              v-model="filterParam.gradeName"
              placeholder="请选择年级"
              filterable
              clearable
              @change="changeGrade()"
          >
            <el-option
                v-for="cgn in gradeNameList"
                :key="cgn"
                :label="cgn"
                :value="cgn">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="班级" prop="className">
          <el-select
              style="width: 120px"
              v-model="filterParam.className"
              placeholder="请选择年级"
              filterable
              clearable
              @change="initCheckStudentList()"
          >
            <el-option
                v-for="cgn in gradeClassNameList"
                :key="cgn"
                :label="cgn"
                :value="cgn">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录入状态" prop="recordStatus">
          <el-select
              style="width: 120px"
              v-model="filterParam.recordStatus"
              placeholder="请选择状态"
              clearable
              @change="initCheckStudentList()"
          >
            <el-option label="" value="0">全部</el-option>
            <el-option
                v-for="item in filterParamOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录入日期" prop="dateRanges">
          <el-date-picker
              v-model="dateRanges"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="initCheckStudentList"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
              size="medium"
              icon="el-icon-search"
              type="primary"
              @click="initCheckStudentList()"
              style="margin-right: 8px"
          >
            搜索
          </el-button>
          <el-upload
              class="upload-btn mr-8"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onSuccess"
              :on-error="onError"
              :disabled="importDataDisabled"
              action="/vhr/export/uploadCheckStudentInfos"
          >
            <el-button
                :disabled="importDataDisabled"
                type="success"
                size="medium"
                :icon="importDataBtnIcon"
            >学生基础信息导入
            </el-button>
          </el-upload>
          <el-button
              type="primary"
              size="medium"
              icon="el-icon-plus"
              @click="showCreateCheckListDialog=true"
          >
            生成检查单
          </el-button>
          <el-button
              class="mr-8"
              size="medium"
              @click="deleteAllCheckList()"
              icon="el-icon-delete"
              type="danger"
              v-show="allCheckStudents.length>0"
          >
            清除所有数据
          </el-button>
          <!--                    <el-button-->
          <!--                        type="primary"-->
          <!--                        size="medium"-->
          <!--                        @click="jumpExpReport"-->
          <!--                    >-->
          <!--                      专家管理-->
          <!--                    </el-button>-->
        </el-form-item>
      </el-form>
    </div>

    <div class="tableContainer">
      <el-table
          class="dataTable"
          :data="allCheckStudents"
          stripe
          border
          v-loading="loading"
          element-loading-text="正在加载学生清单..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :header-cell-style="tableHeaderColor "
      >
        <el-table-column
            type="index"
            label="序号"
            width="50"
            align="center"
        ></el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="year"
            width="80"
            label="年份"
        >
        </el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="serialNo"
            width="120"
            label="编号"
        >
        </el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="schoolName"
            width="280"
            label="学校名称">
        </el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="countyname"
            width="120"
            label="地区">
        </el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="nationname"
            width="120"
            label="民族">
        </el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="gradeName"
            width="120"
            label="年级">
        </el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="classCode"
            width="150"
            label="班级编号"
        ></el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="className"
            width="150"
            label="班级名称">
        </el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="schoolenrnum"
            width="150"
            label="学籍号"
        ></el-table-column>
        <el-table-column
            align="center"
            show-overflow-tooltip
            prop="studentName"
            label="姓名"
            width="120">
        </el-table-column>
        <el-table-column
            align="center"
            show-overflow-tooltip
            prop="gendername"
            label="性别"
            width="60">
        </el-table-column>
        <el-table-column
            align="center"
            show-overflow-tooltip
            prop="recordStatus"
            label="是否录入"
            width="100">
          <template slot-scope="scope">
            <el-tag :type="'1' == scope.row.recordStatus ? 'danger' : 'success'">
              {{ calcRecordStatusTxt(scope.row.recordStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="createTime"
            width="220"
            label="创建时间"
        >
        </el-table-column>
        <el-table-column align="center" fixed="right" width="150" label="操作">
          <template slot-scope="scope">
            <el-button
                @click="editCheckListInfo(scope.row)"
                style="padding: 3px"
                size="mini"
                icon="el-icon-edit"
                type="primary"
            >编辑
            </el-button>
            <el-button
                @click="deleteCheckStudent(scope.row)"
                style="padding: 3px"
                size="mini"
                type="danger"
                icon="el-icon-delete"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex; justify-content: flex-end; padding-top: 8px">
        <el-pagination
            background
            @current-change="currentChange"
            @size-change="sizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 创建检查单 -->
    <el-dialog
        title="创建检查单"
        :visible.sync="showCreateCheckListDialog"
        width="50%"
        :before-close="handleClose"
        center
    >
      <div>
        <el-form ref="checkListInfoForm" :model="filterParam" :rules="checkListInfoRules" label-width="120px">
          <el-form-item label="检查单样式:" prop="templateType">
            <el-radio-group v-model="filterParam.templateType" @change="changeTemplate">
              <el-radio :label="1">全版（A4）</el-radio>
              <el-radio :label="2">简版（A5）</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="检查单标题:" prop="title">
            <el-input v-model="filterParam.title" placeholder="请输入检查单标题..."/>
          </el-form-item>
          <el-form-item label="登记表标题:" prop="djbTitle">
            <el-input v-model="filterParam.djbTitle" placeholder="请输入检查单登记表标题..."/>
          </el-form-item>
          <el-form-item label="登记表副标题:" prop="djbSubhead">
            <el-input v-model="filterParam.djbSubhead" placeholder="请输入检查单登记表副标题..."/>
          </el-form-item>
          <el-form-item label="携带检查机构:" prop="takeCheckDep">
            <el-radio-group v-model="filterParam.takeCheckDep" :disabled="checkDepDisable">
              <el-radio :label="1">携带</el-radio>
              <el-radio :label="2">不携带</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="空白模板份数:" prop="blankTemplateNum">
            <el-input-number v-model="filterParam.blankTemplateNum" :min="0" :max="100"
                             label="请输入导出空白检查单份数..."></el-input-number>
            份
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCreateCheckListDialog = false">取 消</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="exportCheckList()">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import FileSaver from "file-saver";

export default {
  name: "CheckList",
  data() {
    return {
      //所有学生检查单列表
      allCheckStudents: [],
      filterParam: {
        year:'',
        schoolName: "",
        gradeName: "",
        className: '',
        studentName: '',
        keyword: '',
        title: '',
        djbTitle: '',
        djbSubhead: "",
        templateType: 1, //模板样式类型 1：全版 2：简版
        takeCheckDep: 1, //模板样式类型 1：携带 2：不携带
        blankTemplateNum: 0, //生成空白模板的份数
        recordStatus: '',
        countyname: '',

      },
      dateRanges: [], //日期范围
      checkDepDisable: false,
      title: "",
      assetdialogtitle: "征信信息分析",
      importDataBtnIcon: "el-icon-upload2",
      importDataDisabled: false,
      loading: false,
      total: 0,
      page: 1,
      size: 10,
      url: {
        page: "/employee/basic/page",
        loadCheckStudentUrl: "/employee/basic/loadCheckList",
        exportCheckListUrl: "/employee/basic/downloadCheckListReport",
        deleteCheckStudentUrl: "/employee/basic/deleteCheckStudent"
      },
      borrowerAsset: {
        borroweridnum: null,
        income: null,
        house: null,
        store: null,
        dailyUse: null,
        loan: null,
        creditCard: null,
        totalAsset: null,
        riskLevel: null,
        maxAsset: null,
      },
      showCreateCheckListDialog: false,
      checkListInfoRules: {
        title: [{required: true, message: '请输入检查单总标题', trigger: 'blur'}],
        djbTitle: [{required: true, message: '请输入检查单登记表标题', trigger: 'blur'}],
        djbSubhead: [{required: true, message: '请输入检查单登记表副标题', trigger: 'blur'}],
        takeCheckDep: [{required: true, message: '请选是否携带检查机构信息', trigger: 'change'}],
        templateType: [{required: true, message: '请选择模板类型', trigger: 'change'}],
        blankTemplateNum: [{type: 'number', message: '年龄必须为数字值'}],
      },
      filterParamOptions: [
        {label: '未录入', value: '1'},
        {label: '已录入', value: '2'},
      ],
      countynameList: [],
      schoolNameList: [],
      gradeNameList: [], //学校所在年级信息 - 与学校联动
      gradeClassNameList: [], //学校所在年级信息 - 与学校联动
    }
  },
  mounted() {
    this.initCheckStudentList()
    this.initSchoollist()
    this.initGradeList()
    this.initCountygradenames()
  },
  methods: {
getCurrentYear() {
  return new Date().getFullYear()
},
    initSchoollist() {
      this.getRequest("/student/getStudentSchoolList").then((resp) => {
        if (resp && resp.status) {
          this.schoolNameList = resp.data;
        }
      });
    },
    changeSchool() {
      //清空年级、班级
      this.gradeNameList = []
      this.filterParam.gradeName = ''
      this.initGradeList()
      this.initCheckStudentList()
    },
    changeGrade() {
      this.gradeClassNameList = []
      this.filterParam.className = ''
      this.initClassList()
      this.initCheckStudentList()
    },
    initGradeList() {
      let params = {
        schoolName: this.filterParam.schoolName
      }
      this.getRequest("/student/getSchoolGradeList", {params: params}).then((resp) => {
        if (resp && resp.status) {
          this.gradeNameList = resp.data;
        }
      });
    },
    initClassList() {
      this.gradeClassNameList = []
      let params = {
        schoolName: this.filterParam.schoolName,
        gradeName: this.filterParam.gradeName,
      }
      this.getRequest("/student/getGradeClassList", {params: params}).then((resp) => {
        if (resp && resp.status) {
          this.gradeClassNameList = resp.data;
        }
      });
    },
    calcRecordStatusTxt(recordStatus) {
      let txt = "";
      if ("1" == recordStatus) {
        txt = "未录入"
      } else if ("2" == recordStatus) {
        txt = "已录入"
      }
      return txt
    },
    changeTemplate() {
      if (this.filterParam.templateType == 2) {
        this.filterParam.takeCheckDep = 2
        this.checkDepDisable = true
      } else if (this.filterParam.templateType == 1) {
        this.filterParam.takeCheckDep = 1
        this.checkDepDisable = false
      }
    },
    tableHeaderColor() {
      return 'background:	#DCDFE6; color:#000000;';
    },

    onError(err, file, fileList) {
      this.importDataBtnIcon = "el-icon-upload2";
      this.importDataDisabled = false;
    },
    onSuccess(response, file, fileList) {
      this.importDataBtnIcon = "el-icon-upload";
      this.importDataDisabled = false;
      this.initCheckStudentList();
    },

    beforeUpload() {
      this.importDataBtnText = "正在导入";
      this.importDataBtnIcon = "el-icon-loading";
      this.importDataDisabled = true;
    },
    editCheckListInfo(student) {
      console.log("跳跳糖...", student.serialNo)
      this.$router.push({
        path: '/manageCheckListInfo',
        query: {
          serialNo: student.serialNo
        }
      });
    },
    deleteCheckStudent(student) {
      this.$confirm(
          "此操作将永久删除【" + student.studentName + "】, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).then(() => {
        this.deleteRequest(this.url.deleteCheckStudentUrl, {
          checkStudentId: student.id
        }).then((resp) => {
          if (resp && resp.status) {
            this.initCheckStudentList();
          }
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    jumpExpReport() {
      this.$router.push({
        path: '/expertMange'
      });
    },
    deleteAllCheckList() {
      this.$confirm(
          "此操作将永久删除所有数据, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      )
          .then(() => {
            this.deleteRequest("/employee/basic/deleteAllCheckList").then((resp) => {
              if (resp && resp.status) {
                this.initCheckStudentList();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },

    sizeChange(currentSize) {
      this.size = currentSize;
      this.initCheckStudentList();
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initCheckStudentList();
    },

    initCheckStudentList() {
      this.loading = true;
      console.log("检索条件:",this.filterParam,'日期范围：',this.dateRanges)
      //构建条件
      let queryParam = {
        ...this.filterParam,
        startDate:this.dateRanges[0],
        endDate:this.dateRanges[1],
        page: this.page,
        size: this.size
      }
      try {
        this.postRequest(this.url.loadCheckStudentUrl, queryParam).then((resp) => {
          if (resp && resp.status) {
            this.allCheckStudents = resp.data.records;
            this.total = resp.data.total
          }
        }).catch(e => console.log(e.message))
            .finally(() => {
              this.loading = false;
            })
      } catch (error) {
        alert('学生信息加载失败！');
        this.loading = false;
        console.log(error.message)
      }
    },
    initCountygradenames() {
      //构建条件
      try {
        this.getRequest('/student/getStudentCountys').then((resp) => {
          if (resp && resp.status) {
            this.countynameList = resp.data;
          }
        })
      } catch (error) {
        alert('学生信息加载失败！');
        console.log(error.message)
      }

    },

    // async exportCheckList() {
    //   console.log("导出检查单...")
    //   this.loading = true;
    //   let queryParam = {
    //     ...this.filterParam
    //   }
    //   try {
    //       this.getRequest('/employee/basic/downloadCheckListReport', {
    //         params:queryParam,
    //         responseType: 'blob'
    //       }).then((res) => {
    //         FileSaver.saveAs(
    //           new Blob([res], {
    //             type: `application/*`,
    //           }),
    //           `checkList.doc`
    //         );
    //     });
    //     this.showCreateCheckListDialog = false
    //     this.loading = false;
    //   } catch (error) {
    //     alert('文件下载失败');
    //   }
    // },

    async exportCheckList() {
      console.log()
      let loading = this.$loading({
        lock: true,
        text: '检查单下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$refs["checkListInfoForm"].validate((valid) => {
        if (valid) {
          let queryParam = {
            ...this.filterParam,
            startDateStr:this.dateRanges[0],
            endDateStr:this.dateRanges[1]
          }
          this.getRequest('/employee/basic/downloadCheckListReport', {
            params: queryParam,
            responseType: 'arraybuffer',
            timeout: 0
          }).then((res) => {
            FileSaver.saveAs(
                new Blob([res], {
                  type: `application/force-download`
                }),
                `${this.filterParam.title}检查单.zip`
            );
          })
              .catch(e => console.log(e.message))
              .finally(() => {
                loading.close();
                this.showCreateCheckListDialog = false
                this.initCheckStudentList()
              });
        }
      })
    },


    handleClose() {
    }
  },
};
</script>

<style scoped>
.mainContainer {
  height: calc(100vh - 126px);
  background: rgba(246, 245, 245, 0.62);
}

.filterContainer {
  padding: 8px;
  height: 36px;
  width: 98%;
  text-align: right;
  border: 1px solid #dedddd;
  border-radius: 4px;
  margin-bottom: 8px;
}

.filterInp ::v-deep .el-input__inner {
  width: 300px;
}

.upload-btn {
  display: inline-block;
}

.tableContainer {
  height: calc(100% - 52px);
  border: 1px solid #dedddd;
  border-radius: 4px;
}

.dataTable {
  width: 100%;
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}

#chardiv {
  display: flex;
}

#testChart {
  width: 50%;
  height: 500px;
}

#testChart2 {
  width: 50%;
  height: 500px;
}
</style>
